export const sessionOptions = {
    password: "2gyZ3GDw3LHZQKDhPmPDL3sjREVRXPr7",
    cookieName: "ab-session",
    cookieOptions: {
        secure: process.env.NODE_ENV === "production",
    },
};
